<template>
  <v-card elevation="1">
    <v-card-text>
      <div class="mb-5" :class="mobile ? 'w-100' : 'w-50'">
        <h2 class="mb-2">Як налаштувати інтеграцію</h2>
        <span>
          Інтеграція з вашою ERP суттєво прискорить створення та надсилання
          звітності до Регулятора та дозволить працювати у звичному для вас
          програмному середовищі.
        </span>
      </div>
      <div>
        <Item :content="content1" image="oneC" />
        <Item :content="content2" image="api" class="mt-10 mb-10" />
        <Item :content="content3" image="best" class="mt-10" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Item from '@/pages/integration/components/Item.vue'
import { useDisplay } from 'vuetify'

export default defineComponent({
  components: {
    Item,
  },
  setup() {
    const content1 = [
      {
        type: 'title',
        data: 'Інтеграція з 1С',
      },
      {
        type: 'paragraph',
        data: 'Якщо всі ваші дані зберігаються та формуються в 1С, ви можете отримати обробку для 1С. Це дозволяє:',
      },
      {
        type: 'list',
        data: [
          'Обирати і формувати необхідні дані для направлення їх у сервіс CR2.0' +
            '(формат XML/JSON)',
          'Імпортувати звіти у сервіс «CR2.0» з заповненими даними по договору',
          'Оновлювати статуси пакетів, що надіслані в НБУ',
          'Вивантажувати список не провалідованих пакетів з сервісу «CR2.0» ',
        ],
      },
      {
        type: 'paragraph',
        data: 'Налаштувавши інтеграцію з CR2.0, ви будете мати актуальний статус даних у вашій 1С. Процесс підписання відбуватиметься через WEB інтерфейс «CR2.0».',
      },
      {
        type: 'tip',
        data: [
          {
            type: 'text',
            data: 'Для отримання обробки для 1С, оберіть версію 1С, у котрій ви працюєте. Там ви знайдете обробку для 1С та інструкцію з її встановлення.',
          },
        ],
      },
    ]
    const content2 = [
      {
        type: 'title',
        data: 'Інтеграція з CRM та ERP',
      },
      {
        type: 'paragraph',
        data: 'Для інтеграції CRM або ERP використовуйте API. Новий API підтримує роботу зі звітами та пакетами версій 1 і 2.',
      },
      {
        type: 'list',
        data: [
          'Створювати звіти та пакети версії 1 або 2 без змішування версій у межах одного звіту',
          'Валідувати, підписувати, надсилати пакети та перевіряти їх статус',
          'Отримувати дані та статуси пакетів',
        ],
      },
      {
        type: 'paragraph',
        data: 'Для нових інтеграцій використовуйте API /api/integration/v1.',
      },
      {
        type: 'tip',
        data: [
          {
            type: 'text',
            data: 'Інструкція нового API:',
          },
          {
            type: 'link',
            data: 'Завантажити файл',
            href: '/integrationInstruction/integrationApi.pdf',
          },
          {
            type: 'text',
            data: 'Інструкція API v2:',
          },
          {
            type: 'link',
            data: 'Завантажити файл',
            href: '/integrationInstruction/api.pdf',
          },
          {
            type: 'text',
            data: 'API v2 підтримується до 31.03.2027 включно.',
          },
        ],
      },
    ]
    const content3 = [
      {
        type: 'title',
        data: 'Інтеграція з підписанням прямо в CRM/ERP',
      },
      {
        type: 'list',
        data: [
          'Ця можливість актуальна для компаній з великим обсягом вихідних документів і дозволяє підписувати більше ніж 10 000 документів за 30 хвилин',
          'Вона дозволяє зручно підписувати документи без зайвих зусиль',
        ],
      },
      {
        type: 'btn',
        data: 'Дізнатися більше',
      },
    ]

    const { mobile } = useDisplay()

    return {
      content1,
      content2,
      content3,
      mobile,
    }
  },
})
</script>

<style lang="scss"></style>
